import { render, staticRenderFns } from "./PageIllustration.vue?vue&type=template&id=f3f72d46&"
import script from "./PageIllustration.vue?vue&type=script&lang=js&"
export * from "./PageIllustration.vue?vue&type=script&lang=js&"
import style0 from "./PageIllustration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports